import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetRoleListing(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminGetRoleListingAttempt', handleGetRoleListing, api);
}

function* handleGetRoleListing(api: AdminGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index } = reduxState.admin.roleListing;

    if (!index && index !== 0) {
        yield put(combinedActions.adminGetRoleListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.getRoleListing], {
        authToken,
        index,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminGetRoleListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminGetRoleListingSuccess(response.data));
    }
}
